import rollbar from '../../util/rollbar';

export const NS = '@@rollbar';
export const IDENTIFY = `${NS}/identify`;
export const RESET = `${NS}/reset`;

const dispatch = (action = {}, opts = {}) => {
  const instance = opts.rollbar || rollbar();
  if (!instance) return;

  const { type, payload = {} } = action || {};
  const { person = {} } = payload;

  switch (type) {
    case IDENTIFY:
      return instance.configure({
        payload: { person }
      });
    case RESET:
      return instance.configure({ payload: { person: null } });
    default:
  }
};

export default function createTracker(
  middleware,
  options = {} // eslint-disable-line no-unused-vars
) {
  return store => {
    return next => action => {
      middleware(dispatch, store.getState(), action);
      return next(action);
    };
  };
}



// WEBPACK FOOTER //
// ./js/store/middleware/rollbar.js